// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"883":"a7812e5fc45fbb09","3381":"40bf52894f1ab521","4106":"6d10c70c6882c28d"}[chunkId] + ".css";
};